import handler from 'api/handler'

const prefix = '/userAdmin/meetings/users'

const meetingUsers = {
  search: q => handler({ method: 'get', url: `${prefix}/search`, args: { q } })
}

export default meetingUsers

